<!-- 公告 -->
<template>
    <div v-if="componentsData.type == 3">
        <div class="content" :style="`background: ${componentsData.content.bg_color};`">
            <img class="content-img" :style="`width: ${componentsData.content.size * 1.5}px;height: ${componentsData.content.size * 1.5}px;`"
                :src="componentsData.content.imgs.picview"
            />
            <div class="content-txt" :style="`font-size: ${componentsData.content.size}px;color: ${componentsData.content.text_color};`">
                {{ componentsData.content.text }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    },
};
</script>

<style scoped>
.content {
    padding: 12px;
    display: flex;
    align-items: center;
}
.content-img {
    margin: 0 6px 0 0;
    /* height: auto; */
}
.content-txt {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>